import { ObjectSchema, object, string, mixed } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { FcuNetworkType, FcuUnitNetwork, fcuNetwork } from './../../models/fcu-unit-network';
import './../custom-method';

yup.setLocale(locale);

export function fcuUnitNetWorkValidator(): ObjectSchema<FcuUnitNetwork> {
    return object({
        id: string().uuid().strict(),
        vesselId: string().uuid().strict(),
        fcuId: string().uuid().strict(),
        networkType: mixed<FcuNetworkType>().oneOf(Object.values(fcuNetwork)).nullable().strict(),
        LineAIp: string().isIp().nullable().strict(),
        LineBIp: string().isIp().nullable().strict(),
        fieldNetLineAIp: string().isIp().nullable().strict(),
        fieldNetLineBIp: string().isIp().nullable().strict(),
        ceuCommLineAIp: string().isIp().nullable().strict(),
        ceuCommLineBIp: string().isIp().nullable().strict(),
    })
        .strict()
        .noUnknown();
}
